var heading_default = {
  "fontElementMap": "N5gtA",
  "elementSpacing": "r-its",
  "headerOne": "_9VK2k r-its",
  "headerTwo": "eLhpl r-its",
  "headerThree": "pY5y9 r-its",
  "headerFour": "Pqe-i r-its",
  "headerFive": "nwg-9 r-its",
  "headerSix": "k7g-b r-its",
  "child": "S7ivw"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
